function initCeAnimation() {
    let $lottieplayers = $("lottie-player");
    if ($lottieplayers.length) {
        // start animation when player becomes visible
        const aniObserver = new IntersectionObserver(
            function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        let player = entry.target;
                        player.play();
                        aniObserver.unobserve(player);
                    }
                });
            },
            {threshold: [0.1]}
        );
        // load lottie-player.js only when needed
        $.getScript('/typo3conf/ext/od_t3template/Resources/Public/JavaScript/Vendor/lottie-player.js', function() {
            // start animation when player becomes visible
            $lottieplayers.each(function () {
                aniObserver.observe(this);
            })
        });
    }
}